import { formatDate } from '@btime/helpers'
import mexp from 'math-expression-evaluator'

const UUID_V4 = new RegExp(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi)
const FIELD_ID = new RegExp(/:field(\d+)/gi)
const hasValue = value => value || value === 0
const cleanValue = value => hasValue(value) && parseFloat(value)
const extractFieldsId = calc => calc?.match(FIELD_ID).map(match => parseInt(match.replace(/:field/, ''))) || []
const hasFieldValues = value => value?.fieldValues && value?.fieldValues.length > 0

export const isCalcReady = calc => calc && !calc.match(UUID_V4)?.length && !calc.match(FIELD_ID)?.length

export const isDefaultValueReady = defaultValue =>
  defaultValue && !defaultValue.match(UUID_V4)?.length && !defaultValue.match(FIELD_ID)?.length

export const extractRelatedRepliesRefs = calc => calc?.match(UUID_V4) || []

export const sanitizeBeforeCalc = value => value && value.replace(/\.(\d{3})/g, '$1').replace(/,/g, '.')

export const replaceKeyWithValue = (calc, key, value) => {
  if (!/:reply:/.test(calc)) return calc

  const clearValue = cleanValue(value)

  if (hasFieldValues(value)) {
    const fieldsId = extractFieldsId(calc)
    const fieldValues = value.fieldValues.filter(item => fieldsId.includes(item?.field?.id))
    const field = fieldValues.find(item => item.field.id === fieldsId[0])

    if (!field?.value) return
    const clearValue = cleanValue(field?.value)

    return hasValue(field) && calc?.replace(`:reply:ref${key}:field${field?.field?.id}`, clearValue)
  }

  return hasValue(clearValue) && calc?.replace(`:reply:ref${key}`, clearValue)
}

export const replaceKeyWithDefaultValue = (defaultValue, key, value) => {
  if (!/:reply:/.test(defaultValue)) return defaultValue

  const arrayValue = Array.isArray(value) ? value : [value]

  const allValues = []

  let field = undefined
  const fieldsId = extractFieldsId(defaultValue)

  arrayValue.forEach(value => {
    if (!hasFieldValues(value)) return

    const fieldValues = value.fieldValues.filter(item => fieldsId.includes(item.field.id))
    field = fieldValues.filter(item => item.field?.id === fieldsId[0])
    const fieldType = field[0]?.field?.type

    if (!field.length) return allValues

    if (fieldType === 'select') {
      return hasValue(field) && allValues.push(field[0].value.name)
    }

    if (fieldType === 'checkbox') {
      return hasValue(field) && allValues.push(field[0].value ? 'Sim' : 'Não')
    }

    if (fieldType === 'date') {
      return hasValue(field) && allValues.push(formatDate('DD/MM/YYYY', field[0].value))
    }

    if (fieldType === 'datetime') {
      return hasValue(field) && allValues.push(formatDate('DD/MM/YYYY HH:MM', field[0].value))
    }

    if (fieldType === 'address') {
      return hasValue(field) && allValues.push(field[0].value)
    }

    return field && field[0] && hasValue(field) && allValues.push(field[0].value)
  })

  return defaultValue?.replace(`:reply:ref${key}:field${fieldsId[0]}`, allValues.join(', '))
}

export const calcAndFix = finalCalc => {
  try {
    const result = mexp.eval(finalCalc)

    if (!isFinite(result)) return '0'

    return result?.toString()?.includes('.') ? result.toFixed(2).toString() : result.toString()
  } catch (error) {
    console.log(error.message)
    return 'Houve um problema com esta pergunta.'
  }
}

export const setValueWhenCalcIsReady = (components, element, calc) => {
  const result = isCalcReady(calc) ? calcAndFix(calc) : undefined
  components?.current[element.questionId]?.setValue(result)
}

export const setValueWhenDefaultValueIsReady = (components, element, calc) => {
  const result = isDefaultValueReady(calc) ? calc : ''
  components?.current[element.questionId]?.setValue(result)
}
